export const GET_TIERS_SUCCESS = 'GET_TIERS_SUCCESS';
export const GET_TIERS_REQUESTED = 'GET_TIERS_REQUESTED';
export const DELETE_TIERS_REQUESTED = 'DELETE_TIERS_REQUESTED';
export const ADD_TIER_REQUESTED = 'ADD_TIER_REQUESTED';
export const UPDATE_TIER_REQUESTED = 'UPDATE_TIER_REQUESTED';
